const spanish_provinces = [
	{ "value": "", "label": "Seleccione provincia..." },
	{ "value": "A CORUÑA", "label": "A Coruña" },
	{ "value": "ALBACETE", "label": "Albacete" },
	{ "value": "ALICANTE", "label": "Alicante" },
	{ "value": "ALMERIA", "label": "Almería" },
	{ "value": "ARABA", "label": "Araba" },
	{ "value": "ASTURIAS", "label": "Asturias" },
	{ "value": "AVILA", "label": "Ávila" },
	{ "value": "BADAJOZ", "label": "Badajoz" },
	{ "value": "BARCELONA", "label": "Barcelona" },
	{ "value": "BIZKAIA", "label": "Bizkaia" },
	{ "value": "BURGOS", "label": "Burgos" },
	{ "value": "CACERES", "label": "Cáceres" },
	{ "value": "CADIZ", "label": "Cádiz" },
	{ "value": "CANTABRIA", "label": "Cantabria" },
	{ "value": "CASTELLON", "label": "Castellón" },
	{ "value": "CEUTA", "label": "Ceuta" },
	{ "value": "CIUDAD REAL", "label": "Ciudad Real" },
	{ "value": "CORDOBA", "label": "Córdoba" },
	{ "value": "CUENCA", "label": "Cuenca" },
	{ "value": "GIPUZKOA", "label": "Gipuzkoa" },
	{ "value": "GIRONA", "label": "Girona" },
	{ "value": "GRANADA", "label": "Granada" },
	{ "value": "GUADALAJARA", "label": "Guadalajara" },
	{ "value": "HUELVA", "label": "Huelva" },
	{ "value": "HUESCA", "label": "Huesca" },
	{ "value": "ILLES BALEARS", "label": "Illes Balears" },
	{ "value": "JAEN", "label": "Jaén" },
	{ "value": "LA RIOJA", "label": "La Rioja" },
	{ "value": "LAS PALMAS", "label": "Las Palmas" },
	{ "value": "LEON", "label": "León" },
	{ "value": "LLEIDA", "label": "Lleida" },
	{ "value": "LUGO", "label": "Lugo" },
	{ "value": "MADRID", "label": "Madrid" },
	{ "value": "MALAGA", "label": "Málaga" },
	{ "value": "MELILLA", "label": "Melilla" },
	{ "value": "MURCIA", "label": "Murcia" },
	{ "value": "NAVARRA", "label": "Navarra" },
	{ "value": "OURENSE", "label": "Ourense" },
	{ "value": "PALENCIA", "label": "Palencia" },
	{ "value": "PONTEVEDRA", "label": "Pontevedra" },
	{ "value": "SALAMANCA", "label": "Salamanca" },
	{ "value": "SEGOVIA", "label": "Segovia" },
	{ "value": "SEVILLA", "label": "Sevilla" },
	{ "value": "SORIA", "label": "Soria" },
	{ "value": "TARRAGONA", "label": "Tarragona" },
	{ "value": "TENERIFE", "label": "Tenerife" },
	{ "value": "TERUEL", "label": "Teruel" },
	{ "value": "TOLEDO", "label": "Toledo" },
	{ "value": "VALENCIA", "label": "Valencia" },
	{ "value": "VALLADOLID", "label": "Valladolid" },
	{ "value": "ZAMORA", "label": "Zamora" },
	{ "value": "ZARAGOZA", "label": "Zaragoza" }
]

export default spanish_provinces;
